module.exports = __webpack_public_path__ + "static/images/cover_D3.f7c4b0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/cover_D3.png
// module id = YShe
// module chunks = 8